import _ from 'lodash';

export default {
  data: () => ({
    defaultOptions: {
      audio: [],
      audioAlbums: [],
      audioCollections: [],
      df: [],
      docs: [],
      galleries: [],
      locations: [],
      people: [],
      qa: [],
      series: [],
      permissions: [],
    },
    defaultOptionsLoaders: {
      permissions: false,
    },
  }),

  methods: {
    $_getDefaultAudio() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}content-types/media_audio`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.defaultOptions.audio = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((error) => { console.error(error); });
    },
    $_getDefaultAlbums() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/audio-albums`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.defaultOptions.audioAlbums = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((error) => { console.error(error); });
    },
    $_getDefaultCollections() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/audio-albums/collections`, { useCache: true })
        .then((response) => {
          this.defaultOptions.audioCollections = response.data;
        })
        .catch((error) => { console.error(error); });
    },
    $_getDefaultDocuments() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}content-types/media_doc`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.defaultOptions.docs = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((error) => { console.error(error); });
    },
    $_getDefaultDF() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/document-files`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.defaultOptions.df = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    $_getDefaultGalleries() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/image-galleries`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.defaultOptions.galleries = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((error) => { console.error(error); });
    },
    $_getDefaultLocations() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}locations`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.defaultOptions.locations = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    $_getDefaultPeople() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}people`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.defaultOptions.people = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    $_getDefaultQa() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}questions-and-answers`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.defaultOptions.qa = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    $_getDefaultSeries() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/video-series`, { useCache: true })
        .then((response) => {
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          this.defaultOptions.series = Object.keys(newDataArr).map(e => newDataArr[e]);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    $_getDefaultPermissions() {
      this.defaultOptionsLoaders.permissions = true;
      this.$apiHttp.get(`${this.$config.app_api.prefix}permissions`, { useCache: true })
        .then((response) => {
          this.defaultOptions.permissions = response.data;
        })
        .catch((error) => { console.error(error); })
        .finally(() => { this.defaultOptionsLoaders.permissions = false; });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/DefaultOptionsRequests.js